/**
 * urlType.js
 *
 * @description Determines if a URL is absolute.
 */

/**
 * Determines if a URL is an absolute URL.
 *
 *  Source: https://stackoverflow.com/a/38979205/224988
 *
 * @param {String} url The URL to check.
 * @returns `true` if the URL is absolute, otherwise `false`.
 */
export function isUrlAbsolute (url) {
  if (url.indexOf('http://localhost:') === 0) { return true } // URL is local, i.e. for development purposes (= absolute)
  if (url.indexOf('//') === 0) { return true } // URL is protocol-relative (= absolute)
  if (url.indexOf('://') === -1) { return false } // URL has no protocol (= relative)
  if (url.indexOf('.') === -1) { return false } // URL does not contain a dot, i.e. no TLD (= relative, possibly REST)
  if (url.indexOf('/') === -1) { return false } // URL does not contain a single slash (= relative)
  if (url.indexOf(':') > url.indexOf('/')) { return false } // The first colon comes after the first slash (= relative)
  if (url.indexOf('://') < url.indexOf('.')) { return true } // Protocol is defined before first dot (= absolute)
  return false // Anything else must be relative
}
